import API from "./api";

// GET ALL CATEGORIES
export const getCategories = async () => {
  const res = await API.get("/categories");
  return res.data;
};

// CREATE CATEGORY
export const createCategory = async (data) => {
  const res = await API.post("/categories", data);
  return res.data.category;
};

// UPDATE CATEGORY
export const updateCategory = async (id, data) => {
  const res = await API.put(`/categories/${id}`, data);
  return res.data.category;
};

// DELETE CATEGORY
export const deleteCategory = async (id) => {
  const res = await API.delete(`/categories/${id}`);
  return res.data;
};

// GET SINGLE CATEGORY
export const getCategoryById = async (id) => {
  const res = await API.get(`/categories/${id}`);
  return res.data;
};